import React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import DitheredRadialGradientRGB from '../common/utils/DitheredRadialGradientRGB';
import EditorHeaderSkeleton from '../design-system/components/skeletons/editor-header-skeleton';
import Prealoder from './preloader';
import noop from '../utils/noop';

class StarterScreen extends React.Component {
  animationContainerRef;
  canvas;
  static defaultProps = {
    className: null,
    onEntered: noop,
  };

  static renderRadialGradient({ canvas, width, height, colorStart, colorEnd }) {
    const ctx = canvas.getContext('2d');
    const canvasInstance = canvas;

    canvasInstance.width = width;
    canvasInstance.height = height;

    const dgrad = new DitheredRadialGradientRGB(
      width / 2,
      height / 2,
      0,
      width / 2,
      height / 2,
      height
    );

    dgrad.addColorStop(0, colorStart[0], colorStart[1], colorStart[2]);
    dgrad.addColorStop(1, colorEnd[0], colorEnd[1], colorEnd[2]);
    dgrad.fillRect(ctx, 0, 0, width, height);

    ctx.shadowBlur = 0;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { info } = prevState;
    const infoIsUpdated = info !== nextProps.progress.info;

    if (infoIsUpdated) {
      return {
        newInfo: nextProps.progress.info,
        info: infoIsUpdated ? info : nextProps.progress.info,
        textAnimation: infoIsUpdated,
      };
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      textAnimation: false,
      info: props.progress.info,
      newInfo: null,
    };
    this.animationContainerRef = React.createRef();

    this.bindMethods();
  }

  componentDidMount() {
    const { width, height } = this.props;
    StarterScreen.renderRadialGradient({
      canvas: this.canvas,
      height,
      width,
      colorStart: [255, 255, 255],
      colorEnd: [250, 251, 252],
    });
  }

  componentDidUpdate() {
    const textAnimationDuration = 300;
    const { textAnimation, newInfo } = this.state;

    if (textAnimation && newInfo) {
      setTimeout(() => {
        this.setState({
          info: newInfo,
          newInfo: null,
          textAnimation: false,
        });
      }, textAnimationDuration);
    }
  }

  setCanvasRef(canvas) {
    this.canvas = canvas;
  }

  hide() {
    this.setState({
      hide: true,
    });
  }

  bindMethods() {
    this.hide = this.hide.bind(this);
    this.setCanvasRef = this.setCanvasRef.bind(this);
  }

  render() {
    const { progress, captions, logo, className, onEntered } = this.props;
    const {
      value: progressValue,
      initialValue: initialProgressValue,
      preventInfoAnimation,
    } = progress;
    const { textAnimation, hide, info } = this.state;

    const wrapperClass = classNames('ws-starter-screen', className, {
      'ws-starter-screen--hide': hide,
    });

    const loadingStatusClass = classNames('ws-starter-screen__status', {
      'ws-starter-screen__status--fade-out': !preventInfoAnimation && textAnimation,
      'ws-starter-screen__status--fade-in': !preventInfoAnimation && !textAnimation,
    });

    return (
      <div className={wrapperClass}>
        <section className="ws-starter-screen__container">
          <div className="ws-starter-screen__header">
            <EditorHeaderSkeleton />
          </div>
          <div className="ws-starter-screen__loader">
            {/* @ts-ignore TS(2322): Type '() => void' is not assignable to type 'never... Remove this comment to see the full error message */}
            <Prealoder
              onAnimationEnd={this.hide}
              initialValue={initialProgressValue}
              value={progressValue}
            />
          </div>
          <CSSTransition
            nodeRef={this.animationContainerRef}
            onEntered={onEntered}
            in={!hide}
            appear
            timeout={350}
            classNames="ws-starter-screen__wrap"
          >
            <div className="ws-starter-screen__wrap" ref={this.animationContainerRef}>
              <div className="ws-starter-screen__header">
                <span className={loadingStatusClass}>{info}</span>
              </div>

              <div className="ws-starter-screen__body">
                <div className="ws-starter-screen__brand">
                  <span className="ws-starter-screen__brand-name">{captions.productName}</span>
                  <span className="ws-starter-screen__brand-slogan">{captions.productSlogan}</span>
                </div>
              </div>

              <div className="ws-starter-screen__footer">
                <img
                  src={logo.src}
                  alt="logo"
                  className="ws-starter-screen__logo"
                  style={{ width: logo.width, height: logo.height }}
                />
                {captions.copyright && (
                  <p className="ws-starter-screen__rights">{captions.copyright}</p>
                )}
              </div>

              <canvas
                ref={this.setCanvasRef}
                width="100%"
                height="100%"
                className="ws-starter-screen__canvas-bg"
              />
            </div>
          </CSSTransition>
        </section>
      </div>
    );
  }
}

export default StarterScreen;
